import { Environment } from '@digital-platform/rs-shared/domain';

export const environment: Environment = {
  production: false,
  apiKey: 'AqtJny5C0SbLkuHaZRZVJ1aZZrrec20voTz656Xh3CMbTxoP7sd9E2re5KcPVRqk',
};
